module.exports = __webpack_public_path__ + "img/common.219c2d4d.svg";